import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProject } from '../selectors/projectsSelectors';
import { getEnabledIntegrationPartnersByBusinessId } from '../services/getEnabledIntegrationPartnersByBusinessId';

export const loadBusinessIntegrationPartnersForAnyProject = createAsyncThunk(
  'projects/loadBusinessIntegrationPartnersForAnyProject',
  async (_, { getState }) => {
    const selectedProject = selectSelectedProject(getState());

    const businessId = selectedProject.business_id;

    if (!businessId) {
      return { businessId, integrationPartner: null };
    }
    const integrationPartners = await getEnabledIntegrationPartnersByBusinessId(
      selectedProject.business_id
    );

    return { businessId, integrationPartners };
  }
);
